export default {
  DARK_THEME: 0,
  LIGHT_THEME: 1,
};
